export default "__VITE_ASSET__CfPAWCPw__"